export const QUICK_ENTRY_PREFS_KEY = 'nitro-claw-quick-entry';
export const QUICK_ENTRY_ACTION_EVENT = 'quick-entry-action';
/** Cross-window: main shell prepended a chat — NSPanel should mirror locally. */ export const AGENT_CHAT_HISTORY_UPDATED_EVENT = 'agent-chat-history-updated';
/** Fixed global shortcut — not user-configurable. */ export const DEFAULT_QUICK_ENTRY_ACCELERATOR = 'Alt+Space';
export const DEFAULT_QUICK_ENTRY_PREFS = {
    enabled: true,
    accelerator: DEFAULT_QUICK_ENTRY_ACCELERATOR,
    runInBackground: true
};
/**
 * Read prefs. Shortcut + enable are fixed product defaults (ignore stale
 * localStorage values from older builds that allowed customization).
 */ export const readQuickEntryPrefs = ()=>{
    try {
        const raw = localStorage.getItem(QUICK_ENTRY_PREFS_KEY);
        if (!raw) {
            return DEFAULT_QUICK_ENTRY_PREFS;
        }
        const parsed = JSON.parse(raw);
        return {
            enabled: true,
            accelerator: DEFAULT_QUICK_ENTRY_ACCELERATOR,
            runInBackground: typeof parsed.runInBackground === 'boolean' ? parsed.runInBackground : DEFAULT_QUICK_ENTRY_PREFS.runInBackground
        };
    } catch (unused) {
        return DEFAULT_QUICK_ENTRY_PREFS;
    }
};
export const writeQuickEntryPrefs = (prefs)=>{
    localStorage.setItem(QUICK_ENTRY_PREFS_KEY, JSON.stringify({
        ...prefs,
        enabled: true,
        accelerator: DEFAULT_QUICK_ENTRY_ACCELERATOR
    }));
};
